import { BillState } from '@features/bills/enums/billState'
import { Bill } from '@features/bills/types/bill'
import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'
import { IntegrationStatusRejectCode } from '@features/cegidIntegration/enums/IntegrationStatusRejectCode'

import { getLatestIntegrationStatus } from './getLatestIntegrationStatus'

export const BillIntegrationStatusDeletable = new Set<IntegrationStatusRejectCode>([
  IntegrationStatusRejectCode.Other,
  IntegrationStatusRejectCode.DuplicateFile,
  IntegrationStatusRejectCode.FailedToDownload,
  IntegrationStatusRejectCode.EmptyFile,
  IntegrationStatusRejectCode.DuplicateDocumentId,
])

const doesSyncStatusAllowDeletion = ({ integrationStatus }: { integrationStatus?: IntegrationStatus }) => {
  if (!integrationStatus) {
    return true
  }

  const { rejectCode, status } = integrationStatus

  if (status === CegidIntegrationStatus.Failed && rejectCode) {
    return BillIntegrationStatusDeletable.has(rejectCode)
  }

  return false
}

export const isBillDeletable = ({
  bill,
  integrationStatus,
}: {
  bill?: Bill | null
  integrationStatus?: IntegrationStatus[]
}) => {
  const latestIntegrationStatus = getLatestIntegrationStatus(integrationStatus)

  if (bill) {
    // This is a special case where org is in autoForward OFF (bill approved)
    // and we check that it actually has something sent to the cpa
    if (bill.state === BillState.Approved && Boolean(latestIntegrationStatus)) {
      return false
    }
  }

  return doesSyncStatusAllowDeletion({
    integrationStatus: latestIntegrationStatus,
  })
}

export const isBillVoidable = ({
  bill,
  integrationStatus,
}: {
  bill?: Bill | null
  integrationStatus?: IntegrationStatus[]
}) => {
  if (!bill) {
    return false
  }

  // Can only void approved bills
  if (bill.state !== BillState.Approved) {
    return false
  }

  const latestIntegrationStatus = getLatestIntegrationStatus(integrationStatus)
  return doesSyncStatusAllowDeletion({
    integrationStatus: latestIntegrationStatus,
  })
}
